import { Platform } from '@angular/cdk/platform';
import { AutofillMonitor } from '@angular/cdk/text-field';
import { Directive, ElementRef, inject, NgZone } from '@angular/core';
import { FormGroupDirective, NgControl, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormField, MatFormFieldControl } from '@angular/material/form-field';
import { MAT_INPUT_VALUE_ACCESSOR, MatInput } from '@angular/material/input';

/**
 * Overrides MatInput focus behavior so that a readonly datepicker input
 * does not cause the label to float and snap back on click (Angular Material regression since v12.1.3).
 */
@Directive({
  selector: 'input[appReadonlyDatepickerInput]',
  providers: [
    { provide: MatInput, useExisting: ReadonlyDatepickerInputDirective },
    { provide: MatFormFieldControl, useExisting: ReadonlyDatepickerInputDirective }
  ],
  standalone: true,
  host: {
    '(focus)': '_focusChanged(true)',
    '(blur)': '_focusChanged(false)'
  }
})
export class ReadonlyDatepickerInputDirective extends MatInput {
  constructor() {
    super(
      inject(ElementRef),
      inject(Platform),
      inject(NgControl, { optional: true, self: true }),
      inject(NgForm, { optional: true }),
      inject(FormGroupDirective, { optional: true }),
      inject(ErrorStateMatcher),
      inject(MAT_INPUT_VALUE_ACCESSOR, { optional: true, self: true }),
      inject(AutofillMonitor),
      inject(NgZone),
      inject(MatFormField, { optional: true })
    );
  }

  override _focusChanged(isFocused: boolean): void {
    if (isFocused !== this.focused && (!this.readonly || !isFocused)) {
      this.focused = isFocused;
      this.stateChanges.next();
    }
  }
}
